import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { categories as mockCategories } from '@/mocks/categories'

export default function Footer() {
  const { t } = useTranslation('common')

  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <div className="w-9 h-9 rounded-xl bg-primary-500 flex items-center justify-center">
                <i className="ri-flashlight-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl text-background-50">
                快猫短视频
              </span>
            </Link>
            <p className="text-foreground-500 text-sm leading-relaxed max-w-xs">
              {t('footer.brandDesc')}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-background-50 text-base mb-4">
              {t('footer.quickLinks')}
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li><Link to="/" className="text-sm text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap">{t('nav.home')}</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap">{t('nav.about')}</Link></li>
              <li><a href="#" className="text-sm text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap">{t('footer.privacy')}</a></li>
              <li><a href="#" className="text-sm text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap">{t('footer.terms')}</a></li>
              <li><a href="#" className="text-sm text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap">{t('footer.help')}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-background-50 text-base mb-4">
              {t('footer.categories')}
            </h4>
            <ul className="flex flex-col gap-2.5">
              {mockCategories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-background-50 text-base mb-4">
              {t('footer.contact')}
            </h4>
            <ul className="flex flex-col gap-3">
              <li className="flex items-center gap-2.5 text-sm text-foreground-500">
                <i className="ri-mail-line text-base"></i>
                <span>{t('footer.email')}</span>
              </li>
              <li className="flex items-center gap-2.5 text-sm text-foreground-500">
                <i className="ri-phone-line text-base"></i>
                <span>{t('footer.phone')}</span>
              </li>
              <li className="flex items-start gap-2.5 text-sm text-foreground-500">
                <i className="ri-map-pin-line text-base mt-0.5"></i>
                <span>{t('footer.address')}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            {t('footer.copyright')}
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center text-foreground-500 hover:text-background-50 hover:bg-primary-500 transition-colors">
              <i className="ri-wechat-line"></i>
            </a>
            <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center text-foreground-500 hover:text-background-50 hover:bg-primary-500 transition-colors">
              <i className="ri-weibo-line"></i>
            </a>
            <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center text-foreground-500 hover:text-background-50 hover:bg-primary-500 transition-colors">
              <i className="ri-tiktok-line"></i>
            </a>
            <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center text-foreground-500 hover:text-background-50 hover:bg-primary-500 transition-colors">
              <i className="ri-bilibili-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}